<template>
  <v-row>
    <add-suggestion></add-suggestion>
    <v-col cols="12">
      <v-row>
        <v-col
          cols="12"
          lg="3"
          v-for="suggestion in suggestions"
          :key="suggestion.id"
        >
          <v-card align="left">
            <v-card-title class="break-word">
              "{{ suggestion.description }}"</v-card-title
            >
            <v-card-subtitle v-if="!suggestion.anonymous">
              <div>Proposed By {{ suggestion.creator }}</div>
              <div>Added On {{ suggestion.date }}</div>
            </v-card-subtitle>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                icon
                large
                color="primary"
                @click="vote(suggestion.id, 'yes')"
              >
                <v-icon>thumb_up</v-icon>
              </v-btn>
              <v-label>
                {{ suggestion.likes }}
              </v-label>
              <v-btn
                icon
                large
                color="secondary"
                @click="vote(suggestion.id, 'no')"
              >
                <v-icon>thumb_down</v-icon>
              </v-btn>
              <v-label>
                {{ suggestion.dislikes }}
              </v-label>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
    <!-- <v-dialog v-model="suggestionDialog">
      <v-card>
        <v-card-title>
          {{ selectedSuggestion.category }}
        </v-card-title>
        <v-card-subtitle> {{ selectedSuggestion.description }}</v-card-subtitle>
      </v-card>
    </v-dialog> -->

    <v-snackbar
      v-model="snackbar"
      color="info darken-1"
      :timeout="3000"
      light
      top
    >
      <v-avatar icon>
        <v-icon color="white" small>check</v-icon>
      </v-avatar>
      {{ snackbarMessage }}
      <v-btn text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-row>
</template>

<script>
import {
  firebaseApp,
  suggestionsRef,
  suggestionVotesRef,
} from "../../../firebaseApp";
import AddSuggestion from "./AddSuggestion.vue";
import suggestionVoteObject from "../../json/suggestion_votes.json";

export default {
  components: { AddSuggestion },
  data: () => ({
    suggestions: [],
    suggestionvote: suggestionVoteObject,
    suggestionDialog: false,
    active: false,
    member: {},
    admin: {},
    likes: 0,
    dislikes: 0,
    selected: [],
    selectedSuggestion: {},
    snackbar: false,
    snackbarMessage: "",
  }),
  methods: {
    loadMemberInfo() {
      this.member = this.$store.state.member;
      this.admin = this.$store.state.admin;
    },
    formatDate(timestamp) {
      var formattedDate = new Date(timestamp);
      formattedDate = formattedDate.toLocaleDateString("en-US");
      return formattedDate;
    },
    openSuggestion(suggestion) {
      this.selectedSuggestion = suggestion;
      this.suggestionDialog = true;
    },
    updateVote(voteKey, value) {
      firebaseApp
        .database()
        .ref("suggestionvotes/" + voteKey)
        .update({
          vote: value,
        });
    },
    vote(suggestionId, value) {
      var voteExists = false;
      suggestionVotesRef.once("value", (snap) => {
        snap.forEach((vote) => {
          if (
            vote.val().suggestionKey == suggestionId &&
            vote.val().memberKey == this.member.id
          ) {
            voteExists = true;
            this.updateVote(vote.key, value);
          }
        });
        if (!voteExists) this.addVote(suggestionId, value);
        for (var index = 0; index < this.suggestions.length; index++) {
          var sug = this.suggestions[index];
          this.loadVotes(sug.id, index);
        }
      });
    },
    addVote(suggestionId, vote) {
      this.suggestionvote.dateAdded = Date.now();
      this.suggestionvote.vote = vote;
      this.suggestionvote.memberKey = this.member.id;
      this.suggestionvote.suggestionKey = suggestionId;
      suggestionVotesRef.push(this.suggestionvote).key;
    },
    decreaseLike() {
      this.dislikes++;
    },
    loadVotes(suggestionId, index) {
      suggestionVotesRef.once("value", (snap) => {
        var yesVotes = 0;
        var noVotes = 0;
        snap.forEach((vote) => {
          if (suggestionId == vote.val().suggestionKey) {
            if (vote.val().vote == "yes") yesVotes++;
            else if (vote.val().vote == "no") noVotes++;
          }
        });
        this.suggestions[index].likes = yesVotes;
        this.suggestions[index].dislikes = noVotes;
      });
    },
    loadSuggestions() {
      var communityCode = this.member.communityCode;
      suggestionsRef.on("value", (snap) => {
        var suggestions = [];
        snap.forEach((sug) => {
          if (communityCode == sug.val().communityCode) {
            let suggestion = {};
            suggestion = sug.val();
            suggestion.id = sug.key;
            suggestion.date = this.formatDate(suggestion.dateAdded);
            suggestions.push(suggestion);
          }
        });
        var ordered = suggestions.reverse();
        this.suggestions = ordered;
        for (var index = 0; index < this.suggestions.length; index++) {
          var sug = this.suggestions[index];
          this.loadVotes(sug.id, index);
        }
      });
    },
  },
  mounted() {
    this.loadMemberInfo();
    this.loadSuggestions();
  },
};
</script>